<ng-template
  #indicatorTemplate
  let-indicator>
  @if (indicator?.text) {
    <span
      class="bn-select-indicator ms-2"
      containerClass="tooltip--no-width-limit ms-1"
      placement="right"
      [class.bn-select-indicator--strikethrough]="indicator.strikethrough"
      [tooltip]="indicator.tooltip">
      <span class="bn-select-indicator__text">{{ indicator.text }}</span>
    </span>
  }
</ng-template>
